import * as React from 'react';
import { Theme, StyleRules } from '@material-ui/core/styles';
import withStyles, { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Snackbar, SnackbarContent, IconButton } from '@material-ui/core';
import {
  Close as CloseIcon,
  Error as ErrorIcon,
  Check as CheckCircleIcon,
  Info as InfoIcon,
  Warning as WarningIcon,
} from '@material-ui/icons';
import { green, amber } from '@material-ui/core/colors';
import classNames from 'classnames';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

interface Props {
  messages: string[];
  classes: ClassNameMap;
  onClose?: () => void;
  variant: 'success' | 'warning' | 'error' | 'info';
}

const style = (theme: Theme): StyleRules => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

const SnackbarsMessage: React.SFC<Props> = (props) => {
  const { classes, messages, onClose, variant } = props;
  const Icon = variantIcon[variant];

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={messages && messages.length > 0}
      onClose={onClose}
    >
      <div>
        {messages && messages.map((message, i) => (
          <SnackbarContent
            key={i}
            className={classes[variant]}
            message={
              <span className={classes.message}>
                <Icon className={classNames(classes.icon, classes.iconVariant)} />
                {message}
              </span>
            }
            action={onClose && (i === 0) && [
              <IconButton
                key="close"
                color="inherit"
                className={classes.close}
                onClick={onClose}
              >
                <CloseIcon className={classes.icon} />
              </IconButton>,
            ]}
          />
        ))}
      </div>
    </Snackbar>
  );
};

export default withStyles(style)(SnackbarsMessage);



// WEBPACK FOOTER //
// ./src/components/SnackbarsMessage.tsx